export function createEmptyBooking(tenantId) {
  return {
    id: null,
    tenant: tenantId,
    tenantId,
    assignedUserId: null,
    attachments: [],
    bookableItems: [],
    comment: null,
    company: null,
    couponCode: null,
    isCommitted: false,
    isPayed: false,
    location: null,
    lockerInfo: null,
    mail: null,
    name: null,
    paymentProvider: null,
    paymentMethod: null,
    phone: null,
    priceEur: 0,
    street: null,
    timeBegin: Date.now(),
    timeCreated: Date.now(),
    timeEnd: Date.now() + 2 * 60 * 60 * 1000,
    vatIncludedEur: null,
    zipCode: null,
    customFieldDefinitions: [],
    customFieldValues: [],
  };
}
